import { List } from "antd";
import { renderQuillHtml } from "configs/utils";
import theme from "utils/themeVars";
import QuestionItem from "./questionItem";
import { Title } from "components/common";
import UserActions from "features/quiz/takeQuiz/userActions";

const ViewQuestion = ({
  scriptQuestions,
  showBorder = true,
  showQuestionId = true,
  showUserActions = true,
}) => {
  const onUserAction = (questionDetails) => {
    let tempQuestionsList = JSON.parse(JSON.stringify(scriptQuestions?.[0]));
    tempQuestionsList = {
      ...tempQuestionsList,
      questionDetails: questionDetails,
    };
  };

  const renderItem = (item, index) => {
    return (
      <List.Item style={{ position: "relative", marginBottom: "1%" }}>
        <div
          style={{
            content: '""',
            position: "absolute",
            left: "0",
            top: "4%",
            bottom: "0",
            width: "50%",
            ...(showBorder && { borderLeft: `2px solid ${theme["blue200"]}` }),
          }}
        />
        <List.Item.Meta
          title={
            <div>
              {showUserActions && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    margin: "0px 10px 0px 0px",
                  }}
                >
                  <UserActions
                    question={item}
                    scriptId={item?.scripts?.[0]}
                    onUserAction={onUserAction}
                  />
                </div>
              )}
              {renderQuillHtml(
                `<p>
              <span style="font-weight: bold; font-size: 18px;">Question:</span>
              <span style="display: inline;">${item?.description}</span>
            </p>`,
                undefined,
                {
                  margin: "-10px 0px -10px -10px",
                }
              )}
            </div>
          }
          description={
            <QuestionItem question={item} showQuestionId={showQuestionId} />
          }
        />
      </List.Item>
    );
  };
  return <List dataSource={scriptQuestions} renderItem={renderItem} />;
};

export default ViewQuestion;
